module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "img-back pull-left",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["提醒设置"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right orange",
    on: {
      "click": _vm.saveHandsTime
    }
  }, ["保存"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "remind-list"
  }, [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSelectStudent($event)
      }
    }
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more text-right"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["提醒谁的家长看？"]), " ", _vm._h('span', {
    staticClass: "margin-x-15 gray "
  }, [_vm._s(_vm.studentSelectList.length)])])]), " ", _vm._h('li', {
    staticClass: "list-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openPicker('picker')
      }
    }
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more text-right"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["什么时候提醒？"]), " ", _vm._h('span', {
    staticClass: "margin-x-15 gray "
  }, [_vm._s(_vm.info.handsTime)])])]), " ", _vm._h('li', {
    staticClass: "list-group",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideWeek = false
      }
    }
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more text-right"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["重复"]), " ", _vm._h('span', {
    staticClass: "margin-x-15 gray font-12"
  }, [_vm._l((_vm.weekList), function(week) {
    return (week.isChecked) ? _vm._h('span', ["\n                  " + _vm._s(week.week) + "  \n                "]) : _vm._e()
  })])])])]), " ", _vm._h('span', {
    staticClass: "margin-15"
  }, ["提醒文字"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group padding-15"
  }, [_vm._h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.handsContent),
      expression: "info.handsContent"
    }],
    staticClass: "font-12 gray",
    staticStyle: {
      "height": "120px"
    },
    attrs: {
      "maxlength": "100",
      "placeholder": "默认：少儿之家温馨提醒您：请及时接孩子，您的宝贝在想你！"
    },
    domProps: {
      "value": _vm._s(_vm.info.handsContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.info.handsContent = $event.target.value
      }
    }
  })])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('span', {
    staticClass: "block text-center padding-15",
    on: {
      "click": _vm.deleteRemind
    }
  }, ["删除"])])])])]), " ", " ", _vm._h('dialogStudents', {
    attrs: {
      "isHideSelectStudent": _vm.isHideSelectStudent,
      "studentFirstCharList": _vm.studentList
    },
    on: {
      "close": _vm.closeDialogStudents,
      "selected": _vm.selectedStudent
    }
  }), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideWeek),
      expression: "!isHideWeek"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideWeek = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["重复"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.weekList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          item.isChecked = !item.isChecked
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item.week)]), " ", (item.isChecked) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })]), " ", _vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('a', {
    staticClass: "button button-rounded button-line",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideWeek = true
      }
    }
  }, ["确定"])])])]), " ", _vm._h('mt-datetime-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.handsTime),
      expression: "info.handsTime"
    }],
    ref: "picker",
    attrs: {
      "type": "time",
      "start-hour": 6
    },
    domProps: {
      "value": (_vm.info.handsTime)
    },
    on: {
      "confirm": _vm.handleChange,
      "input": function($event) {
        _vm.info.handsTime = $event
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-2d37026a!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/remind/remindEdit.vue
// module id = 190
// module chunks = 1